module.exports = __webpack_public_path__ + "img/accept-left-circle10.828ad6e3.svg";